import { I18nService } from '../../i18n/I18nService';
import { I18N_KEYS } from '../../i18n/keys';
import { DONATE_VISIBILITY } from '../../constants/donateConfig';

export class HeaderBar {
  private i18n: I18nService;
  private element: HTMLElement;
  private settingsBtn: HTMLButtonElement | null = null;
  private guidelineBtn: HTMLButtonElement | null = null;
  private donateBtn: HTMLButtonElement | null = null;

  onSettingsClick: (() => void) | null = null;
  onGuidelineClick: (() => void) | null = null;
  onDonateClick: (() => void) | null = null;

  constructor(i18n: I18nService) {
    this.i18n = i18n;
    this.element = document.getElementById('header-bar') || document.createElement('header');
  }

  render(): void {
    const showDonate = this.isDonateVisible();

    this.element.innerHTML = `
      <div class="header__content">
        <h1 class="header__title">${this.i18n.t(I18N_KEYS.APP_TITLE)}</h1>
        <div class="header__controls">
          ${showDonate ? `<button id="donate-btn" class="header__donate-btn" type="button">❤️ ${this.i18n.t(I18N_KEYS.DONATE_BUTTON)}</button>` : ''}
          <button id="guideline-btn" class="header__guideline-btn" aria-label="${this.i18n.t(I18N_KEYS.HEADER_GUIDELINE)}" type="button">📋 ${this.i18n.t(I18N_KEYS.HEADER_GUIDELINE)}</button>
          <button id="settings-btn" class="header__settings-btn" aria-label="${this.i18n.t(I18N_KEYS.HEADER_SETTINGS)}" type="button">⚙️</button>
        </div>
      </div>
    `;

    this.settingsBtn = this.element.querySelector('#settings-btn');
    this.guidelineBtn = this.element.querySelector('#guideline-btn');
    this.donateBtn = this.element.querySelector('#donate-btn');

    this.settingsBtn?.addEventListener('click', () => {
      if (this.onSettingsClick) this.onSettingsClick();
    });

    this.guidelineBtn?.addEventListener('click', () => {
      if (this.onGuidelineClick) this.onGuidelineClick();
    });

    this.donateBtn?.addEventListener('click', () => {
      if (this.onDonateClick) this.onDonateClick();
    });
  }

  updateLabels(): void {
    const title = this.element.querySelector('.header__title');
    if (title) title.textContent = this.i18n.t(I18N_KEYS.APP_TITLE);
    if (this.settingsBtn) this.settingsBtn.setAttribute('aria-label', this.i18n.t(I18N_KEYS.HEADER_SETTINGS));
    if (this.guidelineBtn) {
      this.guidelineBtn.textContent = `📋 ${this.i18n.t(I18N_KEYS.HEADER_GUIDELINE)}`;
      this.guidelineBtn.setAttribute('aria-label', this.i18n.t(I18N_KEYS.HEADER_GUIDELINE));
    }

    // Update donate button visibility and label on locale change
    const showDonate = this.isDonateVisible();
    if (this.donateBtn) {
      if (showDonate) {
        this.donateBtn.textContent = `❤️ ${this.i18n.t(I18N_KEYS.DONATE_BUTTON)}`;
        this.donateBtn.style.display = '';
      } else {
        this.donateBtn.style.display = 'none';
      }
    } else if (showDonate) {
      // Button doesn't exist yet but should be visible — re-render
      this.render();
    }
  }

  private isDonateVisible(): boolean {
    const locale = this.i18n.getLocale();
    return DONATE_VISIBILITY[locale] === true;
  }
}
